<div
  class="left-md top-md bg-components-background-neutral-lightest p-xxs pr-md shadow-bottom gap-xxs fixed z-900 flex items-center rounded-lg"
>
  <button [routerLink]="['../../../../..']" hlmBtn variant="ghost" size="xxl">
    <ng-icon name="lucideArrowLeft" />
  </button>
  <span class="component-small-medium text-content-secondary">{{ cartographie().nom }}</span>
  <span class="component-small-medium text-content-secondary">•</span>
  <div class="gap-xxs flex cursor-pointer items-center" [hlmDropdownMenuTrigger]="selectParcours">
    <span class="component-small-semibold text-content-primary">{{ parcoursSelectionne()?.nom || '' }}</span>
    <ng-icon hlm name="lucideChevronDown" size="sm" />
  </div>
  @if (estVerrouille()) {
    <app-chip label="Verrouillé" variant="warning" />
  }

  @if (estCanvasElementsSupprimes() === 'true') {
    <app-chip label="Visualisation des étapes supprimées" />
  }
</div>

<ng-template #selectParcours>
  <hlm-dropdown-menu>
    @for (item of parcours(); track item.id) {
      <button (click)="setParcoursCourant(item)" hlmDropdownMenuItem>{{ item.nom }}</button>
    }
    @if (peutModifier()) {
      <button (click)="creerParcours()" hlmDropdownMenuItem>
        <ng-icon name="lucidePlus" hlm size="sm" />
        Créer un nouveau parcours
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>

<div class="fix-bot-left container">
  <button
    class="paragraph-large-semibold"
    [disabled]="profondeurActuelle() === '01'"
    (click)="quandCliqueSurNiveauPrecedent()"
    hlmBtn
    variant="ghost"
    size="icon"
    aria-label="Revenir au niveau 1"
    hlmTooltipTrigger="Revenir au niveau 1"
  >
    <ng-icon name="lucideMinus" />
  </button>
  <span
    class="component-small-medium text-components-content-neutral-primary"
    aria-label="Choix profondeur du parcours"
  >
    Niveau {{ profondeurActuelle() }}
  </span>
  <button
    class="paragraph-large-semibold"
    [disabled]="profondeurActuelle() === '02'"
    (click)="quandCliqueSurNiveauSuivant()"
    hlmBtn
    variant="ghost"
    size="icon"
    aria-label="Aller à la modularisation"
    hlmTooltipTrigger="Modularisation"
  >
    <ng-icon name="lucidePlus" />
  </button>
</div>

<router-outlet></router-outlet>
